import companyApi from '../../_api'
import i18n from '@/locales'
export default {
  /* - Mileage Categories  - */
  fetchMileageCategories: async (
    { commit, getters, dispatch },
    { pagination = true }
  ) => {
    // if (getters.isCallingExpenses) return
    try {
      // commit('setIsCallingExpenses', true)
      const page = getters.mileageCategoriesCurrentPage
      const filters = getters.mileageCategoriesFilters
      let response = []
      if (pagination) {
        response = await companyApi.getMileageCategories(filters, true, page)
      } else {
        response = await companyApi.getMileageCategories(filters, false, page)
      }
      const lastPage = response.headers['pagination-last-page']
      commit('setMileageCategoriesLastPage', lastPage)
      commit('setMileageCategories', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'expense_fetch_mileage_categories_error'
        },
        { root: true }
      )
    } // finally {
    // commit('setIsCallingExpenses', false)
    // }
  },
  setMileageCategoriesFilters: async ({ commit, dispatch }, filters) => {
    commit('setMileageCategoriesFilters', filters)
    await dispatch('fetchMileageCategories', { pagination: false })
  },
  nextMileageCategoriesPage: ({ commit, dispatch, getters }) => {
    if (getters.isCallingExpenses) return
    commit('incrementMileageCategoriesCurrentPage')
    dispatch('fetchMileageCategories')
  },
  updateMileageCategory: async (
    { commit, dispatch, getters },
    mileageCategory
  ) => {
    if (getters.isCallingExpenses) return
    try {
      commit('setIsCallingExpenses', true)
      const response = await companyApi.putMileageCategory(
        mileageCategory.id,
        mileageCategory
      )
      commit('addMileageCategory', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_update_mileage_category_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_update_mileage_category_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingExpenses', false)
    }
  },
  createMileageCategory: async (
    { commit, dispatch, getters },
    mileageCategory
  ) => {
    if (getters.isCallingExpenses) return
    try {
      commit('setIsCallingExpenses', true)
      const response = await companyApi.postMileageCategory(mileageCategory)
      commit('addMileageCategory', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_create_mileage_category_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_create_mileage_category_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingExpenses', false)
    }
  },
  deleteMileageCategory: async (
    { commit, dispatch, getters },
    mileageCategoryId
  ) => {
    if (getters.isCallingExpenses) return
    try {
      commit('setIsCallingExpenses', true)
      await companyApi.deleteMileageCategory(mileageCategoryId)
      commit('deleteMileageCategory', mileageCategoryId)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_delete_mileage_category_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_delete_mileage_category_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingExpenses', false)
    }
  },
  /* - Diet Categories - */
  fetchDietCategories: async (
    { commit, getters, dispatch },
    { pagination = true }
  ) => {
    // if (getters.isCallingExpenses) return
    try {
      // commit('setIsCallingExpenses', true)
      const page = getters.dietCategoriesCurrentPage
      const filters = getters.dietCategoriesFilters
      let response = {}
      if (pagination) {
        response = await companyApi.getDietCategories(filters, true, page)
      } else {
        response = await companyApi.getDietCategories(filters, false, page)
      }
      const lastPage = response.headers['pagination-last-page']
      commit('setDietCategoriesLastPage', lastPage)
      commit('setDietCategories', response.data)
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'expense_fetch_diet_categories_error' }, { root: true })
    }
    // } finally {
    //   commit('setIsCallingExpenses', false)
    // }
  },
  setDietCategoriesFilters: async ({ commit, dispatch }, filters) => {
    commit('setDietCategoriesFilters', filters)
    await dispatch('fetchDietCategories', { pagination: false })
  },
  nextDietCategoriesPage: ({ commit, getters, dispatch }) => {
    if (getters.isCallingExpenses) return
    commit('incrementDietCategoriesCurrentPage')
    dispatch('fetchDietCategories')
  },

  updateDietCategory: async (
    { commit, dispatch, getters },
    dietCategory
  ) => {
    if (getters.isCallingExpenses) return
    try {
      commit('setIsCallingExpenses', true)
      const response = await companyApi.putDietCategory(
        dietCategory.id,
        dietCategory
      )
      commit('addDietCategory', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_update_diet_category_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_update_diet_category_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingExpenses', false)
    }
  },
  createDietCategory: async (
    { commit, dispatch, getters },
    dietCategory
  ) => {
    if (getters.isCallingExpenses) return
    try {
      commit('setIsCallingExpenses', true)
      const response = await companyApi.postDietCategory(dietCategory)
      commit('addDietCategory', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_create_diet_category_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_create_diet_category_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingExpenses', false)
    }
  },
  deleteDietCategory: async (
    { commit, dispatch, getters },
    dietCategoryId
  ) => {
    if (getters.isCallingExpenses) return
    try {
      commit('setIsCallingExpenses', true)
      await companyApi.putDeleteDietCategory(dietCategoryId)
      commit('deleteDietCategory', dietCategoryId)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_delete_diet_category_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_delete_diet_category_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingExpenses', false)
    }
  },
  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }
}
